/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as CreateAccountRouteImport } from './routes/create-account'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as JoinRouteImport } from './routes/join'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteRouteImport } from './routes/_app/account/route'
import { Route as AppBusinessRouteRouteImport } from './routes/_app/business/route'
import { Route as AppCoachRouteRouteImport } from './routes/_app/coach/route'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as DevBootRouteImport } from './routes/dev/boot'
import { Route as DevCanvasRouteImport } from './routes/dev/canvas'
import { Route as DevGraphicsRouteImport } from './routes/dev/graphics'
import { Route as DevKitRouteImport } from './routes/dev/kit'
import { Route as DevStudioRouteImport } from './routes/dev/studio'
import { Route as DevVoiceRouteImport } from './routes/dev/voice'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingLanguageRouteImport } from './routes/onboarding/language'
import { Route as OnboardingTalkRouteImport } from './routes/onboarding/talk'
import { Route as PTokenRouteImport } from './routes/p/$token'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppAccountAppearanceRouteImport } from './routes/_app/account/appearance'
import { Route as AppAccountDeleteRouteImport } from './routes/_app/account/delete'
import { Route as AppAccountLanguageRouteImport } from './routes/_app/account/language'
import { Route as AppAccountVoiceRouteImport } from './routes/_app/account/voice'
import { Route as AppAccountWorkspacesRouteImport } from './routes/_app/account/workspaces'
import { Route as AppBusinessIndexRouteImport } from './routes/_app/business/index'
import { Route as AppBusinessTeamRouteImport } from './routes/_app/business/_team'
import { Route as AppBusinessKnowsRouteImport } from './routes/_app/business/knows'
import { Route as AppBusinessMapRouteImport } from './routes/_app/business/map'
import { Route as AppCoachIndexRouteImport } from './routes/_app/coach/index'
import { Route as AppCoachThreadIdRouteImport } from './routes/_app/coach/$threadId'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppDashboardArrangeRouteImport } from './routes/_app/dashboard/arrange'
import { Route as AppDashboardNewRouteImport } from './routes/_app/dashboard/new'
import { Route as AppDevAiFirstRouteImport } from './routes/_app/dev/ai-first'
import { Route as AppListsIndexRouteImport } from './routes/_app/lists/index'
import { Route as AppListsListIdRouteImport } from './routes/_app/lists/$listId'
import { Route as AppNewRecordIndexRouteImport } from './routes/_app/new-record/index'
import { Route as AppRecordsIndexRouteImport } from './routes/_app/records/index'
import { Route as AppRecordsRecordIdRouteRouteImport } from './routes/_app/records/$recordId/route'
import { Route as OnboardingEditIndexRouteImport } from './routes/onboarding/edit/index'
import { Route as AppAccountAboutIndexRouteImport } from './routes/_app/account/about.index'
import { Route as AppAccountAboutTermsRouteImport } from './routes/_app/account/about.terms'
import { Route as AppBusinessTeamInviteRouteImport } from './routes/_app/business/_team/invite'
import { Route as AppBusinessTeamTeamRouteImport } from './routes/_app/business/_team/team'
import { Route as AppBusinessConnectorsIndexRouteImport } from './routes/_app/business/connectors/index'
import { Route as AppBusinessJobsIndexRouteImport } from './routes/_app/business/jobs/index'
import { Route as AppBusinessJobsSplatRouteImport } from './routes/_app/business/jobs/$'
import { Route as AppBusinessPeopleUserIdRouteRouteImport } from './routes/_app/business/people/$userId/route'
import { Route as AppBusinessRolesIndexRouteImport } from './routes/_app/business/roles/index'
import { Route as AppBusinessRolesRoleIdRouteImport } from './routes/_app/business/roles/$roleId'
import { Route as AppBusinessRolesNewRouteImport } from './routes/_app/business/roles/new'
import { Route as AppCoachImportsSetupRouteImport } from './routes/_app/coach/imports/setup'
import { Route as AppDashboardCardIdIndexRouteImport } from './routes/_app/dashboard/$cardId/index'
import { Route as AppDashboardCardIdEditRouteImport } from './routes/_app/dashboard/$cardId/edit'
import { Route as AppRecordsRecordIdIndexRouteImport } from './routes/_app/records/$recordId/index'
import { Route as AppRecordsRecordIdAccessRouteImport } from './routes/_app/records/$recordId/access'
import { Route as AppRecordsRecordIdCustomizeRouteRouteImport } from './routes/_app/records/$recordId/customize/route'
import { Route as AppRecordsRecordIdNewEntryRouteImport } from './routes/_app/records/$recordId/new-entry'
import { Route as AppRecordsRecordIdSheetRouteImport } from './routes/_app/records/$recordId/sheet'
import { Route as AppBusinessConnectorsGmailIndexRouteImport } from './routes/_app/business/connectors/gmail/index'
import { Route as AppBusinessPeopleUserIdIndexRouteImport } from './routes/_app/business/people/$userId/index'
import { Route as AppBusinessPeopleUserIdAccessRouteImport } from './routes/_app/business/people/$userId/access'
import { Route as AppBusinessPeopleUserIdActivityRouteImport } from './routes/_app/business/people/$userId/activity'
import { Route as AppBusinessPeopleUserIdInformationRouteImport } from './routes/_app/business/people/$userId/information'
import { Route as AppBusinessPeopleUserIdTeamRouteImport } from './routes/_app/business/people/$userId/team'
import { Route as AppCoachImportsImportIdIndexRouteImport } from './routes/_app/coach/imports/$importId.index'
import { Route as AppCoachImportsImportIdAsideRouteImport } from './routes/_app/coach/imports/$importId.aside'
import { Route as AppRecordsRecordIdCustomizeIndexRouteImport } from './routes/_app/records/$recordId/customize/index'
import { Route as AppRecordsRecordIdCustomizeFormulaRouteImport } from './routes/_app/records/$recordId/customize/formula'
import { Route as AppRecordsRecordIdInsightsIndexRouteImport } from './routes/_app/records/$recordId/insights/index'
import { Route as AppRecordsRecordIdInsightsArrangeRouteImport } from './routes/_app/records/$recordId/insights/arrange'
import { Route as AppRecordsRecordIdInsightsNewRouteImport } from './routes/_app/records/$recordId/insights/new'
import { Route as AppRecordsRecordIdLinksIndexRouteImport } from './routes/_app/records/$recordId/links/index'
import { Route as AppRecordsRecordIdLinksLinkIdRouteImport } from './routes/_app/records/$recordId/links/$linkId'
import { Route as AppRecordsRecordIdLinksNewRouteImport } from './routes/_app/records/$recordId/links/new'
import { Route as AppRecordsRecordIdReportTemplatesIndexRouteImport } from './routes/_app/records/$recordId/report-templates/index'
import { Route as AppRecordsRecordIdReportTemplatesNewRouteImport } from './routes/_app/records/$recordId/report-templates/new'
import { Route as AppBusinessConnectorsGmailRulesNewRouteImport } from './routes/_app/business/connectors/gmail/rules/new'
import { Route as AppRecordsRecordIdEntriesEntryIdIndexRouteImport } from './routes/_app/records/$recordId/entries/$entryId/index'
import { Route as AppRecordsRecordIdEntriesEntryIdEditRouteImport } from './routes/_app/records/$recordId/entries/$entryId/edit'
import { Route as AppRecordsRecordIdEntriesEntryIdFullRouteImport } from './routes/_app/records/$recordId/entries/$entryId/full'
import { Route as AppRecordsRecordIdInsightsCardIdIndexRouteImport } from './routes/_app/records/$recordId/insights/$cardId/index'
import { Route as AppRecordsRecordIdInsightsCardIdEditRouteImport } from './routes/_app/records/$recordId/insights/$cardId/edit'
import { Route as AppRecordsRecordIdReportTemplatesTemplateIdIndexRouteImport } from './routes/_app/records/$recordId/report-templates/$templateId/index'
import { Route as AppRecordsRecordIdReportTemplatesTemplateIdEditRouteImport } from './routes/_app/records/$recordId/report-templates/$templateId/edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAccountRoute = CreateAccountRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRouteRoute = AppAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessRouteRoute = AppBusinessRouteRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => AppRoute,
} as any)
const AppCoachRouteRoute = AppCoachRouteRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicTermsRoute = PublicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => PublicRoute,
} as any)
const DevBootRoute = DevBootRouteImport.update({
  id: '/dev/boot',
  path: '/dev/boot',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCanvasRoute = DevCanvasRouteImport.update({
  id: '/dev/canvas',
  path: '/dev/canvas',
  getParentRoute: () => rootRouteImport,
} as any)
const DevGraphicsRoute = DevGraphicsRouteImport.update({
  id: '/dev/graphics',
  path: '/dev/graphics',
  getParentRoute: () => rootRouteImport,
} as any)
const DevKitRoute = DevKitRouteImport.update({
  id: '/dev/kit',
  path: '/dev/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const DevStudioRoute = DevStudioRouteImport.update({
  id: '/dev/studio',
  path: '/dev/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const DevVoiceRoute = DevVoiceRouteImport.update({
  id: '/dev/voice',
  path: '/dev/voice',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingLanguageRoute = OnboardingLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingTalkRoute = OnboardingTalkRouteImport.update({
  id: '/talk',
  path: '/talk',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountAppearanceRoute = AppAccountAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountDeleteRoute = AppAccountDeleteRouteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountLanguageRoute = AppAccountLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountVoiceRoute = AppAccountVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountWorkspacesRoute = AppAccountWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppBusinessIndexRoute = AppBusinessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessTeamRoute = AppBusinessTeamRouteImport.update({
  id: '/_team',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessKnowsRoute = AppBusinessKnowsRouteImport.update({
  id: '/knows',
  path: '/knows',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessMapRoute = AppBusinessMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppCoachIndexRoute = AppCoachIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCoachRouteRoute,
} as any)
const AppCoachThreadIdRoute = AppCoachThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => AppCoachRouteRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardArrangeRoute = AppDashboardArrangeRouteImport.update({
  id: '/dashboard/arrange',
  path: '/dashboard/arrange',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardNewRoute = AppDashboardNewRouteImport.update({
  id: '/dashboard/new',
  path: '/dashboard/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDevAiFirstRoute = AppDevAiFirstRouteImport.update({
  id: '/dev/ai-first',
  path: '/dev/ai-first',
  getParentRoute: () => AppRoute,
} as any)
const AppListsIndexRoute = AppListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => AppRoute,
} as any)
const AppListsListIdRoute = AppListsListIdRouteImport.update({
  id: '/lists/$listId',
  path: '/lists/$listId',
  getParentRoute: () => AppRoute,
} as any)
const AppNewRecordIndexRoute = AppNewRecordIndexRouteImport.update({
  id: '/new-record/',
  path: '/new-record/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecordsIndexRoute = AppRecordsIndexRouteImport.update({
  id: '/records/',
  path: '/records/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecordsRecordIdRouteRoute = AppRecordsRecordIdRouteRouteImport.update({
  id: '/records/$recordId',
  path: '/records/$recordId',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingEditIndexRoute = OnboardingEditIndexRouteImport.update({
  id: '/edit/',
  path: '/edit/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const AppAccountAboutIndexRoute = AppAccountAboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountAboutTermsRoute = AppAccountAboutTermsRouteImport.update({
  id: '/about/terms',
  path: '/about/terms',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppBusinessTeamInviteRoute = AppBusinessTeamInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AppBusinessTeamRoute,
} as any)
const AppBusinessTeamTeamRoute = AppBusinessTeamTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppBusinessTeamRoute,
} as any)
const AppBusinessConnectorsIndexRoute =
  AppBusinessConnectorsIndexRouteImport.update({
    id: '/connectors/',
    path: '/connectors/',
    getParentRoute: () => AppBusinessRouteRoute,
  } as any)
const AppBusinessJobsIndexRoute = AppBusinessJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessJobsSplatRoute = AppBusinessJobsSplatRouteImport.update({
  id: '/jobs/$',
  path: '/jobs/$',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessPeopleUserIdRouteRoute =
  AppBusinessPeopleUserIdRouteRouteImport.update({
    id: '/people/$userId',
    path: '/people/$userId',
    getParentRoute: () => AppBusinessRouteRoute,
  } as any)
const AppBusinessRolesIndexRoute = AppBusinessRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessRolesRoleIdRoute = AppBusinessRolesRoleIdRouteImport.update({
  id: '/roles/$roleId',
  path: '/roles/$roleId',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppBusinessRolesNewRoute = AppBusinessRolesNewRouteImport.update({
  id: '/roles/new',
  path: '/roles/new',
  getParentRoute: () => AppBusinessRouteRoute,
} as any)
const AppCoachImportsSetupRoute = AppCoachImportsSetupRouteImport.update({
  id: '/imports/setup',
  path: '/imports/setup',
  getParentRoute: () => AppCoachRouteRoute,
} as any)
const AppDashboardCardIdIndexRoute = AppDashboardCardIdIndexRouteImport.update({
  id: '/dashboard/$cardId/',
  path: '/dashboard/$cardId/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardCardIdEditRoute = AppDashboardCardIdEditRouteImport.update({
  id: '/dashboard/$cardId/edit',
  path: '/dashboard/$cardId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppRecordsRecordIdIndexRoute = AppRecordsRecordIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRecordsRecordIdRouteRoute,
} as any)
const AppRecordsRecordIdAccessRoute =
  AppRecordsRecordIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdCustomizeRouteRoute =
  AppRecordsRecordIdCustomizeRouteRouteImport.update({
    id: '/customize',
    path: '/customize',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdNewEntryRoute =
  AppRecordsRecordIdNewEntryRouteImport.update({
    id: '/new-entry',
    path: '/new-entry',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdSheetRoute = AppRecordsRecordIdSheetRouteImport.update({
  id: '/sheet',
  path: '/sheet',
  getParentRoute: () => AppRecordsRecordIdRouteRoute,
} as any)
const AppBusinessConnectorsGmailIndexRoute =
  AppBusinessConnectorsGmailIndexRouteImport.update({
    id: '/connectors/gmail/',
    path: '/connectors/gmail/',
    getParentRoute: () => AppBusinessRouteRoute,
  } as any)
const AppBusinessPeopleUserIdIndexRoute =
  AppBusinessPeopleUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppBusinessPeopleUserIdRouteRoute,
  } as any)
const AppBusinessPeopleUserIdAccessRoute =
  AppBusinessPeopleUserIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AppBusinessPeopleUserIdRouteRoute,
  } as any)
const AppBusinessPeopleUserIdActivityRoute =
  AppBusinessPeopleUserIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppBusinessPeopleUserIdRouteRoute,
  } as any)
const AppBusinessPeopleUserIdInformationRoute =
  AppBusinessPeopleUserIdInformationRouteImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => AppBusinessPeopleUserIdRouteRoute,
  } as any)
const AppBusinessPeopleUserIdTeamRoute =
  AppBusinessPeopleUserIdTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AppBusinessPeopleUserIdRouteRoute,
  } as any)
const AppCoachImportsImportIdIndexRoute =
  AppCoachImportsImportIdIndexRouteImport.update({
    id: '/imports/$importId/',
    path: '/imports/$importId/',
    getParentRoute: () => AppCoachRouteRoute,
  } as any)
const AppCoachImportsImportIdAsideRoute =
  AppCoachImportsImportIdAsideRouteImport.update({
    id: '/imports/$importId/aside',
    path: '/imports/$importId/aside',
    getParentRoute: () => AppCoachRouteRoute,
  } as any)
const AppRecordsRecordIdCustomizeIndexRoute =
  AppRecordsRecordIdCustomizeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRecordsRecordIdCustomizeRouteRoute,
  } as any)
const AppRecordsRecordIdCustomizeFormulaRoute =
  AppRecordsRecordIdCustomizeFormulaRouteImport.update({
    id: '/formula',
    path: '/formula',
    getParentRoute: () => AppRecordsRecordIdCustomizeRouteRoute,
  } as any)
const AppRecordsRecordIdInsightsIndexRoute =
  AppRecordsRecordIdInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdInsightsArrangeRoute =
  AppRecordsRecordIdInsightsArrangeRouteImport.update({
    id: '/insights/arrange',
    path: '/insights/arrange',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdInsightsNewRoute =
  AppRecordsRecordIdInsightsNewRouteImport.update({
    id: '/insights/new',
    path: '/insights/new',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdLinksIndexRoute =
  AppRecordsRecordIdLinksIndexRouteImport.update({
    id: '/links/',
    path: '/links/',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdLinksLinkIdRoute =
  AppRecordsRecordIdLinksLinkIdRouteImport.update({
    id: '/links/$linkId',
    path: '/links/$linkId',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdLinksNewRoute =
  AppRecordsRecordIdLinksNewRouteImport.update({
    id: '/links/new',
    path: '/links/new',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdReportTemplatesIndexRoute =
  AppRecordsRecordIdReportTemplatesIndexRouteImport.update({
    id: '/report-templates/',
    path: '/report-templates/',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdReportTemplatesNewRoute =
  AppRecordsRecordIdReportTemplatesNewRouteImport.update({
    id: '/report-templates/new',
    path: '/report-templates/new',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppBusinessConnectorsGmailRulesNewRoute =
  AppBusinessConnectorsGmailRulesNewRouteImport.update({
    id: '/connectors/gmail/rules/new',
    path: '/connectors/gmail/rules/new',
    getParentRoute: () => AppBusinessRouteRoute,
  } as any)
const AppRecordsRecordIdEntriesEntryIdIndexRoute =
  AppRecordsRecordIdEntriesEntryIdIndexRouteImport.update({
    id: '/entries/$entryId/',
    path: '/entries/$entryId/',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdEntriesEntryIdEditRoute =
  AppRecordsRecordIdEntriesEntryIdEditRouteImport.update({
    id: '/entries/$entryId/edit',
    path: '/entries/$entryId/edit',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdEntriesEntryIdFullRoute =
  AppRecordsRecordIdEntriesEntryIdFullRouteImport.update({
    id: '/entries/$entryId/full',
    path: '/entries/$entryId/full',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdInsightsCardIdIndexRoute =
  AppRecordsRecordIdInsightsCardIdIndexRouteImport.update({
    id: '/insights/$cardId/',
    path: '/insights/$cardId/',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdInsightsCardIdEditRoute =
  AppRecordsRecordIdInsightsCardIdEditRouteImport.update({
    id: '/insights/$cardId/edit',
    path: '/insights/$cardId/edit',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute =
  AppRecordsRecordIdReportTemplatesTemplateIdIndexRouteImport.update({
    id: '/report-templates/$templateId/',
    path: '/report-templates/$templateId/',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)
const AppRecordsRecordIdReportTemplatesTemplateIdEditRoute =
  AppRecordsRecordIdReportTemplatesTemplateIdEditRouteImport.update({
    id: '/report-templates/$templateId/edit',
    path: '/report-templates/$templateId/edit',
    getParentRoute: () => AppRecordsRecordIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/': typeof AppIndexRoute
  '/create-account': typeof CreateAccountRoute
  '/get-started': typeof GetStartedRoute
  '/join': typeof JoinRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account': typeof AppAccountRouteRouteWithChildren
  '/business': typeof AppBusinessRouteRouteWithChildren
  '/coach': typeof AppCoachRouteRouteWithChildren
  '/search': typeof AppSearchRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/dev/boot': typeof DevBootRoute
  '/dev/canvas': typeof DevCanvasRoute
  '/dev/graphics': typeof DevGraphicsRoute
  '/dev/kit': typeof DevKitRoute
  '/dev/studio': typeof DevStudioRoute
  '/dev/voice': typeof DevVoiceRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/talk': typeof OnboardingTalkRoute
  '/p/$token': typeof PTokenRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/records/$recordId': typeof AppRecordsRecordIdRouteRouteWithChildren
  '/account/appearance': typeof AppAccountAppearanceRoute
  '/account/delete': typeof AppAccountDeleteRoute
  '/account/language': typeof AppAccountLanguageRoute
  '/account/voice': typeof AppAccountVoiceRoute
  '/account/workspaces': typeof AppAccountWorkspacesRoute
  '/business/knows': typeof AppBusinessKnowsRoute
  '/business/map': typeof AppBusinessMapRoute
  '/coach/$threadId': typeof AppCoachThreadIdRoute
  '/dashboard/arrange': typeof AppDashboardArrangeRoute
  '/dashboard/new': typeof AppDashboardNewRoute
  '/dev/ai-first': typeof AppDevAiFirstRoute
  '/lists/$listId': typeof AppListsListIdRoute
  '/account/': typeof AppAccountIndexRoute
  '/business/': typeof AppBusinessIndexRoute
  '/coach/': typeof AppCoachIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/lists/': typeof AppListsIndexRoute
  '/new-record/': typeof AppNewRecordIndexRoute
  '/records/': typeof AppRecordsIndexRoute
  '/onboarding/edit/': typeof OnboardingEditIndexRoute
  '/business/people/$userId': typeof AppBusinessPeopleUserIdRouteRouteWithChildren
  '/records/$recordId/customize': typeof AppRecordsRecordIdCustomizeRouteRouteWithChildren
  '/account/about/terms': typeof AppAccountAboutTermsRoute
  '/business/invite': typeof AppBusinessTeamInviteRoute
  '/business/team': typeof AppBusinessTeamTeamRoute
  '/business/jobs/$': typeof AppBusinessJobsSplatRoute
  '/business/roles/$roleId': typeof AppBusinessRolesRoleIdRoute
  '/business/roles/new': typeof AppBusinessRolesNewRoute
  '/coach/imports/setup': typeof AppCoachImportsSetupRoute
  '/dashboard/$cardId/edit': typeof AppDashboardCardIdEditRoute
  '/records/$recordId/access': typeof AppRecordsRecordIdAccessRoute
  '/records/$recordId/new-entry': typeof AppRecordsRecordIdNewEntryRoute
  '/records/$recordId/sheet': typeof AppRecordsRecordIdSheetRoute
  '/account/about/': typeof AppAccountAboutIndexRoute
  '/business/connectors/': typeof AppBusinessConnectorsIndexRoute
  '/business/jobs/': typeof AppBusinessJobsIndexRoute
  '/business/roles/': typeof AppBusinessRolesIndexRoute
  '/dashboard/$cardId/': typeof AppDashboardCardIdIndexRoute
  '/records/$recordId/': typeof AppRecordsRecordIdIndexRoute
  '/business/people/$userId/access': typeof AppBusinessPeopleUserIdAccessRoute
  '/business/people/$userId/activity': typeof AppBusinessPeopleUserIdActivityRoute
  '/business/people/$userId/information': typeof AppBusinessPeopleUserIdInformationRoute
  '/business/people/$userId/team': typeof AppBusinessPeopleUserIdTeamRoute
  '/coach/imports/$importId/aside': typeof AppCoachImportsImportIdAsideRoute
  '/records/$recordId/customize/formula': typeof AppRecordsRecordIdCustomizeFormulaRoute
  '/records/$recordId/insights/arrange': typeof AppRecordsRecordIdInsightsArrangeRoute
  '/records/$recordId/insights/new': typeof AppRecordsRecordIdInsightsNewRoute
  '/records/$recordId/links/$linkId': typeof AppRecordsRecordIdLinksLinkIdRoute
  '/records/$recordId/links/new': typeof AppRecordsRecordIdLinksNewRoute
  '/records/$recordId/report-templates/new': typeof AppRecordsRecordIdReportTemplatesNewRoute
  '/business/connectors/gmail/': typeof AppBusinessConnectorsGmailIndexRoute
  '/business/people/$userId/': typeof AppBusinessPeopleUserIdIndexRoute
  '/coach/imports/$importId/': typeof AppCoachImportsImportIdIndexRoute
  '/records/$recordId/customize/': typeof AppRecordsRecordIdCustomizeIndexRoute
  '/records/$recordId/insights/': typeof AppRecordsRecordIdInsightsIndexRoute
  '/records/$recordId/links/': typeof AppRecordsRecordIdLinksIndexRoute
  '/records/$recordId/report-templates/': typeof AppRecordsRecordIdReportTemplatesIndexRoute
  '/business/connectors/gmail/rules/new': typeof AppBusinessConnectorsGmailRulesNewRoute
  '/records/$recordId/entries/$entryId/edit': typeof AppRecordsRecordIdEntriesEntryIdEditRoute
  '/records/$recordId/entries/$entryId/full': typeof AppRecordsRecordIdEntriesEntryIdFullRoute
  '/records/$recordId/insights/$cardId/edit': typeof AppRecordsRecordIdInsightsCardIdEditRoute
  '/records/$recordId/report-templates/$templateId/edit': typeof AppRecordsRecordIdReportTemplatesTemplateIdEditRoute
  '/records/$recordId/entries/$entryId/': typeof AppRecordsRecordIdEntriesEntryIdIndexRoute
  '/records/$recordId/insights/$cardId/': typeof AppRecordsRecordIdInsightsCardIdIndexRoute
  '/records/$recordId/report-templates/$templateId/': typeof AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/create-account': typeof CreateAccountRoute
  '/get-started': typeof GetStartedRoute
  '/join': typeof JoinRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/search': typeof AppSearchRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/dev/boot': typeof DevBootRoute
  '/dev/canvas': typeof DevCanvasRoute
  '/dev/graphics': typeof DevGraphicsRoute
  '/dev/kit': typeof DevKitRoute
  '/dev/studio': typeof DevStudioRoute
  '/dev/voice': typeof DevVoiceRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/talk': typeof OnboardingTalkRoute
  '/p/$token': typeof PTokenRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/account/appearance': typeof AppAccountAppearanceRoute
  '/account/delete': typeof AppAccountDeleteRoute
  '/account/language': typeof AppAccountLanguageRoute
  '/account/voice': typeof AppAccountVoiceRoute
  '/account/workspaces': typeof AppAccountWorkspacesRoute
  '/business': typeof AppBusinessIndexRoute
  '/business/knows': typeof AppBusinessKnowsRoute
  '/business/map': typeof AppBusinessMapRoute
  '/coach/$threadId': typeof AppCoachThreadIdRoute
  '/dashboard/arrange': typeof AppDashboardArrangeRoute
  '/dashboard/new': typeof AppDashboardNewRoute
  '/dev/ai-first': typeof AppDevAiFirstRoute
  '/lists/$listId': typeof AppListsListIdRoute
  '/account': typeof AppAccountIndexRoute
  '/coach': typeof AppCoachIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/lists': typeof AppListsIndexRoute
  '/new-record': typeof AppNewRecordIndexRoute
  '/records': typeof AppRecordsIndexRoute
  '/onboarding/edit': typeof OnboardingEditIndexRoute
  '/account/about/terms': typeof AppAccountAboutTermsRoute
  '/business/invite': typeof AppBusinessTeamInviteRoute
  '/business/team': typeof AppBusinessTeamTeamRoute
  '/business/jobs/$': typeof AppBusinessJobsSplatRoute
  '/business/roles/$roleId': typeof AppBusinessRolesRoleIdRoute
  '/business/roles/new': typeof AppBusinessRolesNewRoute
  '/coach/imports/setup': typeof AppCoachImportsSetupRoute
  '/dashboard/$cardId/edit': typeof AppDashboardCardIdEditRoute
  '/records/$recordId/access': typeof AppRecordsRecordIdAccessRoute
  '/records/$recordId/new-entry': typeof AppRecordsRecordIdNewEntryRoute
  '/records/$recordId/sheet': typeof AppRecordsRecordIdSheetRoute
  '/account/about': typeof AppAccountAboutIndexRoute
  '/business/connectors': typeof AppBusinessConnectorsIndexRoute
  '/business/jobs': typeof AppBusinessJobsIndexRoute
  '/business/roles': typeof AppBusinessRolesIndexRoute
  '/dashboard/$cardId': typeof AppDashboardCardIdIndexRoute
  '/records/$recordId': typeof AppRecordsRecordIdIndexRoute
  '/business/people/$userId/access': typeof AppBusinessPeopleUserIdAccessRoute
  '/business/people/$userId/activity': typeof AppBusinessPeopleUserIdActivityRoute
  '/business/people/$userId/information': typeof AppBusinessPeopleUserIdInformationRoute
  '/business/people/$userId/team': typeof AppBusinessPeopleUserIdTeamRoute
  '/coach/imports/$importId/aside': typeof AppCoachImportsImportIdAsideRoute
  '/records/$recordId/customize/formula': typeof AppRecordsRecordIdCustomizeFormulaRoute
  '/records/$recordId/insights/arrange': typeof AppRecordsRecordIdInsightsArrangeRoute
  '/records/$recordId/insights/new': typeof AppRecordsRecordIdInsightsNewRoute
  '/records/$recordId/links/$linkId': typeof AppRecordsRecordIdLinksLinkIdRoute
  '/records/$recordId/links/new': typeof AppRecordsRecordIdLinksNewRoute
  '/records/$recordId/report-templates/new': typeof AppRecordsRecordIdReportTemplatesNewRoute
  '/business/connectors/gmail': typeof AppBusinessConnectorsGmailIndexRoute
  '/business/people/$userId': typeof AppBusinessPeopleUserIdIndexRoute
  '/coach/imports/$importId': typeof AppCoachImportsImportIdIndexRoute
  '/records/$recordId/customize': typeof AppRecordsRecordIdCustomizeIndexRoute
  '/records/$recordId/insights': typeof AppRecordsRecordIdInsightsIndexRoute
  '/records/$recordId/links': typeof AppRecordsRecordIdLinksIndexRoute
  '/records/$recordId/report-templates': typeof AppRecordsRecordIdReportTemplatesIndexRoute
  '/business/connectors/gmail/rules/new': typeof AppBusinessConnectorsGmailRulesNewRoute
  '/records/$recordId/entries/$entryId/edit': typeof AppRecordsRecordIdEntriesEntryIdEditRoute
  '/records/$recordId/entries/$entryId/full': typeof AppRecordsRecordIdEntriesEntryIdFullRoute
  '/records/$recordId/insights/$cardId/edit': typeof AppRecordsRecordIdInsightsCardIdEditRoute
  '/records/$recordId/report-templates/$templateId/edit': typeof AppRecordsRecordIdReportTemplatesTemplateIdEditRoute
  '/records/$recordId/entries/$entryId': typeof AppRecordsRecordIdEntriesEntryIdIndexRoute
  '/records/$recordId/insights/$cardId': typeof AppRecordsRecordIdInsightsCardIdIndexRoute
  '/records/$recordId/report-templates/$templateId': typeof AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/create-account': typeof CreateAccountRoute
  '/get-started': typeof GetStartedRoute
  '/join': typeof JoinRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_app/account': typeof AppAccountRouteRouteWithChildren
  '/_app/business': typeof AppBusinessRouteRouteWithChildren
  '/_app/coach': typeof AppCoachRouteRouteWithChildren
  '/_app/search': typeof AppSearchRoute
  '/_public/privacy': typeof PublicPrivacyRoute
  '/_public/terms': typeof PublicTermsRoute
  '/dev/boot': typeof DevBootRoute
  '/dev/canvas': typeof DevCanvasRoute
  '/dev/graphics': typeof DevGraphicsRoute
  '/dev/kit': typeof DevKitRoute
  '/dev/studio': typeof DevStudioRoute
  '/dev/voice': typeof DevVoiceRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/talk': typeof OnboardingTalkRoute
  '/p/$token': typeof PTokenRoute
  '/_app/': typeof AppIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_app/records/$recordId': typeof AppRecordsRecordIdRouteRouteWithChildren
  '/_app/account/appearance': typeof AppAccountAppearanceRoute
  '/_app/account/delete': typeof AppAccountDeleteRoute
  '/_app/account/language': typeof AppAccountLanguageRoute
  '/_app/account/voice': typeof AppAccountVoiceRoute
  '/_app/account/workspaces': typeof AppAccountWorkspacesRoute
  '/_app/business/_team': typeof AppBusinessTeamRouteWithChildren
  '/_app/business/knows': typeof AppBusinessKnowsRoute
  '/_app/business/map': typeof AppBusinessMapRoute
  '/_app/coach/$threadId': typeof AppCoachThreadIdRoute
  '/_app/dashboard/arrange': typeof AppDashboardArrangeRoute
  '/_app/dashboard/new': typeof AppDashboardNewRoute
  '/_app/dev/ai-first': typeof AppDevAiFirstRoute
  '/_app/lists/$listId': typeof AppListsListIdRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/business/': typeof AppBusinessIndexRoute
  '/_app/coach/': typeof AppCoachIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/lists/': typeof AppListsIndexRoute
  '/_app/new-record/': typeof AppNewRecordIndexRoute
  '/_app/records/': typeof AppRecordsIndexRoute
  '/onboarding/edit/': typeof OnboardingEditIndexRoute
  '/_app/business/people/$userId': typeof AppBusinessPeopleUserIdRouteRouteWithChildren
  '/_app/records/$recordId/customize': typeof AppRecordsRecordIdCustomizeRouteRouteWithChildren
  '/_app/account/about/terms': typeof AppAccountAboutTermsRoute
  '/_app/business/_team/invite': typeof AppBusinessTeamInviteRoute
  '/_app/business/_team/team': typeof AppBusinessTeamTeamRoute
  '/_app/business/jobs/$': typeof AppBusinessJobsSplatRoute
  '/_app/business/roles/$roleId': typeof AppBusinessRolesRoleIdRoute
  '/_app/business/roles/new': typeof AppBusinessRolesNewRoute
  '/_app/coach/imports/setup': typeof AppCoachImportsSetupRoute
  '/_app/dashboard/$cardId/edit': typeof AppDashboardCardIdEditRoute
  '/_app/records/$recordId/access': typeof AppRecordsRecordIdAccessRoute
  '/_app/records/$recordId/new-entry': typeof AppRecordsRecordIdNewEntryRoute
  '/_app/records/$recordId/sheet': typeof AppRecordsRecordIdSheetRoute
  '/_app/account/about/': typeof AppAccountAboutIndexRoute
  '/_app/business/connectors/': typeof AppBusinessConnectorsIndexRoute
  '/_app/business/jobs/': typeof AppBusinessJobsIndexRoute
  '/_app/business/roles/': typeof AppBusinessRolesIndexRoute
  '/_app/dashboard/$cardId/': typeof AppDashboardCardIdIndexRoute
  '/_app/records/$recordId/': typeof AppRecordsRecordIdIndexRoute
  '/_app/business/people/$userId/access': typeof AppBusinessPeopleUserIdAccessRoute
  '/_app/business/people/$userId/activity': typeof AppBusinessPeopleUserIdActivityRoute
  '/_app/business/people/$userId/information': typeof AppBusinessPeopleUserIdInformationRoute
  '/_app/business/people/$userId/team': typeof AppBusinessPeopleUserIdTeamRoute
  '/_app/coach/imports/$importId/aside': typeof AppCoachImportsImportIdAsideRoute
  '/_app/records/$recordId/customize/formula': typeof AppRecordsRecordIdCustomizeFormulaRoute
  '/_app/records/$recordId/insights/arrange': typeof AppRecordsRecordIdInsightsArrangeRoute
  '/_app/records/$recordId/insights/new': typeof AppRecordsRecordIdInsightsNewRoute
  '/_app/records/$recordId/links/$linkId': typeof AppRecordsRecordIdLinksLinkIdRoute
  '/_app/records/$recordId/links/new': typeof AppRecordsRecordIdLinksNewRoute
  '/_app/records/$recordId/report-templates/new': typeof AppRecordsRecordIdReportTemplatesNewRoute
  '/_app/business/connectors/gmail/': typeof AppBusinessConnectorsGmailIndexRoute
  '/_app/business/people/$userId/': typeof AppBusinessPeopleUserIdIndexRoute
  '/_app/coach/imports/$importId/': typeof AppCoachImportsImportIdIndexRoute
  '/_app/records/$recordId/customize/': typeof AppRecordsRecordIdCustomizeIndexRoute
  '/_app/records/$recordId/insights/': typeof AppRecordsRecordIdInsightsIndexRoute
  '/_app/records/$recordId/links/': typeof AppRecordsRecordIdLinksIndexRoute
  '/_app/records/$recordId/report-templates/': typeof AppRecordsRecordIdReportTemplatesIndexRoute
  '/_app/business/connectors/gmail/rules/new': typeof AppBusinessConnectorsGmailRulesNewRoute
  '/_app/records/$recordId/entries/$entryId/edit': typeof AppRecordsRecordIdEntriesEntryIdEditRoute
  '/_app/records/$recordId/entries/$entryId/full': typeof AppRecordsRecordIdEntriesEntryIdFullRoute
  '/_app/records/$recordId/insights/$cardId/edit': typeof AppRecordsRecordIdInsightsCardIdEditRoute
  '/_app/records/$recordId/report-templates/$templateId/edit': typeof AppRecordsRecordIdReportTemplatesTemplateIdEditRoute
  '/_app/records/$recordId/entries/$entryId/': typeof AppRecordsRecordIdEntriesEntryIdIndexRoute
  '/_app/records/$recordId/insights/$cardId/': typeof AppRecordsRecordIdInsightsCardIdIndexRoute
  '/_app/records/$recordId/report-templates/$templateId/': typeof AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/onboarding'
    | '/'
    | '/create-account'
    | '/get-started'
    | '/join'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/account'
    | '/business'
    | '/coach'
    | '/search'
    | '/privacy'
    | '/terms'
    | '/dev/boot'
    | '/dev/canvas'
    | '/dev/graphics'
    | '/dev/kit'
    | '/dev/studio'
    | '/dev/voice'
    | '/onboarding/language'
    | '/onboarding/talk'
    | '/p/$token'
    | '/onboarding/'
    | '/records/$recordId'
    | '/account/appearance'
    | '/account/delete'
    | '/account/language'
    | '/account/voice'
    | '/account/workspaces'
    | '/business/knows'
    | '/business/map'
    | '/coach/$threadId'
    | '/dashboard/arrange'
    | '/dashboard/new'
    | '/dev/ai-first'
    | '/lists/$listId'
    | '/account/'
    | '/business/'
    | '/coach/'
    | '/dashboard/'
    | '/lists/'
    | '/new-record/'
    | '/records/'
    | '/onboarding/edit/'
    | '/business/people/$userId'
    | '/records/$recordId/customize'
    | '/account/about/terms'
    | '/business/invite'
    | '/business/team'
    | '/business/jobs/$'
    | '/business/roles/$roleId'
    | '/business/roles/new'
    | '/coach/imports/setup'
    | '/dashboard/$cardId/edit'
    | '/records/$recordId/access'
    | '/records/$recordId/new-entry'
    | '/records/$recordId/sheet'
    | '/account/about/'
    | '/business/connectors/'
    | '/business/jobs/'
    | '/business/roles/'
    | '/dashboard/$cardId/'
    | '/records/$recordId/'
    | '/business/people/$userId/access'
    | '/business/people/$userId/activity'
    | '/business/people/$userId/information'
    | '/business/people/$userId/team'
    | '/coach/imports/$importId/aside'
    | '/records/$recordId/customize/formula'
    | '/records/$recordId/insights/arrange'
    | '/records/$recordId/insights/new'
    | '/records/$recordId/links/$linkId'
    | '/records/$recordId/links/new'
    | '/records/$recordId/report-templates/new'
    | '/business/connectors/gmail/'
    | '/business/people/$userId/'
    | '/coach/imports/$importId/'
    | '/records/$recordId/customize/'
    | '/records/$recordId/insights/'
    | '/records/$recordId/links/'
    | '/records/$recordId/report-templates/'
    | '/business/connectors/gmail/rules/new'
    | '/records/$recordId/entries/$entryId/edit'
    | '/records/$recordId/entries/$entryId/full'
    | '/records/$recordId/insights/$cardId/edit'
    | '/records/$recordId/report-templates/$templateId/edit'
    | '/records/$recordId/entries/$entryId/'
    | '/records/$recordId/insights/$cardId/'
    | '/records/$recordId/report-templates/$templateId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/create-account'
    | '/get-started'
    | '/join'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/search'
    | '/privacy'
    | '/terms'
    | '/dev/boot'
    | '/dev/canvas'
    | '/dev/graphics'
    | '/dev/kit'
    | '/dev/studio'
    | '/dev/voice'
    | '/onboarding/language'
    | '/onboarding/talk'
    | '/p/$token'
    | '/onboarding'
    | '/account/appearance'
    | '/account/delete'
    | '/account/language'
    | '/account/voice'
    | '/account/workspaces'
    | '/business'
    | '/business/knows'
    | '/business/map'
    | '/coach/$threadId'
    | '/dashboard/arrange'
    | '/dashboard/new'
    | '/dev/ai-first'
    | '/lists/$listId'
    | '/account'
    | '/coach'
    | '/dashboard'
    | '/lists'
    | '/new-record'
    | '/records'
    | '/onboarding/edit'
    | '/account/about/terms'
    | '/business/invite'
    | '/business/team'
    | '/business/jobs/$'
    | '/business/roles/$roleId'
    | '/business/roles/new'
    | '/coach/imports/setup'
    | '/dashboard/$cardId/edit'
    | '/records/$recordId/access'
    | '/records/$recordId/new-entry'
    | '/records/$recordId/sheet'
    | '/account/about'
    | '/business/connectors'
    | '/business/jobs'
    | '/business/roles'
    | '/dashboard/$cardId'
    | '/records/$recordId'
    | '/business/people/$userId/access'
    | '/business/people/$userId/activity'
    | '/business/people/$userId/information'
    | '/business/people/$userId/team'
    | '/coach/imports/$importId/aside'
    | '/records/$recordId/customize/formula'
    | '/records/$recordId/insights/arrange'
    | '/records/$recordId/insights/new'
    | '/records/$recordId/links/$linkId'
    | '/records/$recordId/links/new'
    | '/records/$recordId/report-templates/new'
    | '/business/connectors/gmail'
    | '/business/people/$userId'
    | '/coach/imports/$importId'
    | '/records/$recordId/customize'
    | '/records/$recordId/insights'
    | '/records/$recordId/links'
    | '/records/$recordId/report-templates'
    | '/business/connectors/gmail/rules/new'
    | '/records/$recordId/entries/$entryId/edit'
    | '/records/$recordId/entries/$entryId/full'
    | '/records/$recordId/insights/$cardId/edit'
    | '/records/$recordId/report-templates/$templateId/edit'
    | '/records/$recordId/entries/$entryId'
    | '/records/$recordId/insights/$cardId'
    | '/records/$recordId/report-templates/$templateId'
  id:
    | '__root__'
    | '/onboarding'
    | '/_app'
    | '/_public'
    | '/create-account'
    | '/get-started'
    | '/join'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/_app/account'
    | '/_app/business'
    | '/_app/coach'
    | '/_app/search'
    | '/_public/privacy'
    | '/_public/terms'
    | '/dev/boot'
    | '/dev/canvas'
    | '/dev/graphics'
    | '/dev/kit'
    | '/dev/studio'
    | '/dev/voice'
    | '/onboarding/language'
    | '/onboarding/talk'
    | '/p/$token'
    | '/_app/'
    | '/onboarding/'
    | '/_app/records/$recordId'
    | '/_app/account/appearance'
    | '/_app/account/delete'
    | '/_app/account/language'
    | '/_app/account/voice'
    | '/_app/account/workspaces'
    | '/_app/business/_team'
    | '/_app/business/knows'
    | '/_app/business/map'
    | '/_app/coach/$threadId'
    | '/_app/dashboard/arrange'
    | '/_app/dashboard/new'
    | '/_app/dev/ai-first'
    | '/_app/lists/$listId'
    | '/_app/account/'
    | '/_app/business/'
    | '/_app/coach/'
    | '/_app/dashboard/'
    | '/_app/lists/'
    | '/_app/new-record/'
    | '/_app/records/'
    | '/onboarding/edit/'
    | '/_app/business/people/$userId'
    | '/_app/records/$recordId/customize'
    | '/_app/account/about/terms'
    | '/_app/business/_team/invite'
    | '/_app/business/_team/team'
    | '/_app/business/jobs/$'
    | '/_app/business/roles/$roleId'
    | '/_app/business/roles/new'
    | '/_app/coach/imports/setup'
    | '/_app/dashboard/$cardId/edit'
    | '/_app/records/$recordId/access'
    | '/_app/records/$recordId/new-entry'
    | '/_app/records/$recordId/sheet'
    | '/_app/account/about/'
    | '/_app/business/connectors/'
    | '/_app/business/jobs/'
    | '/_app/business/roles/'
    | '/_app/dashboard/$cardId/'
    | '/_app/records/$recordId/'
    | '/_app/business/people/$userId/access'
    | '/_app/business/people/$userId/activity'
    | '/_app/business/people/$userId/information'
    | '/_app/business/people/$userId/team'
    | '/_app/coach/imports/$importId/aside'
    | '/_app/records/$recordId/customize/formula'
    | '/_app/records/$recordId/insights/arrange'
    | '/_app/records/$recordId/insights/new'
    | '/_app/records/$recordId/links/$linkId'
    | '/_app/records/$recordId/links/new'
    | '/_app/records/$recordId/report-templates/new'
    | '/_app/business/connectors/gmail/'
    | '/_app/business/people/$userId/'
    | '/_app/coach/imports/$importId/'
    | '/_app/records/$recordId/customize/'
    | '/_app/records/$recordId/insights/'
    | '/_app/records/$recordId/links/'
    | '/_app/records/$recordId/report-templates/'
    | '/_app/business/connectors/gmail/rules/new'
    | '/_app/records/$recordId/entries/$entryId/edit'
    | '/_app/records/$recordId/entries/$entryId/full'
    | '/_app/records/$recordId/insights/$cardId/edit'
    | '/_app/records/$recordId/report-templates/$templateId/edit'
    | '/_app/records/$recordId/entries/$entryId/'
    | '/_app/records/$recordId/insights/$cardId/'
    | '/_app/records/$recordId/report-templates/$templateId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  CreateAccountRoute: typeof CreateAccountRoute
  GetStartedRoute: typeof GetStartedRoute
  JoinRoute: typeof JoinRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  DevBootRoute: typeof DevBootRoute
  DevCanvasRoute: typeof DevCanvasRoute
  DevGraphicsRoute: typeof DevGraphicsRoute
  DevKitRoute: typeof DevKitRoute
  DevStudioRoute: typeof DevStudioRoute
  DevVoiceRoute: typeof DevVoiceRoute
  PTokenRoute: typeof PTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-account': {
      id: '/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof CreateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business': {
      id: '/_app/business'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof AppBusinessRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coach': {
      id: '/_app/coach'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof AppCoachRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/privacy': {
      id: '/_public/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicPrivacyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/terms': {
      id: '/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof PublicTermsRouteImport
      parentRoute: typeof PublicRoute
    }
    '/dev/boot': {
      id: '/dev/boot'
      path: '/dev/boot'
      fullPath: '/dev/boot'
      preLoaderRoute: typeof DevBootRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/canvas': {
      id: '/dev/canvas'
      path: '/dev/canvas'
      fullPath: '/dev/canvas'
      preLoaderRoute: typeof DevCanvasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/graphics': {
      id: '/dev/graphics'
      path: '/dev/graphics'
      fullPath: '/dev/graphics'
      preLoaderRoute: typeof DevGraphicsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/kit': {
      id: '/dev/kit'
      path: '/dev/kit'
      fullPath: '/dev/kit'
      preLoaderRoute: typeof DevKitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/studio': {
      id: '/dev/studio'
      path: '/dev/studio'
      fullPath: '/dev/studio'
      preLoaderRoute: typeof DevStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/voice': {
      id: '/dev/voice'
      path: '/dev/voice'
      fullPath: '/dev/voice'
      preLoaderRoute: typeof DevVoiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/language': {
      id: '/onboarding/language'
      path: '/language'
      fullPath: '/onboarding/language'
      preLoaderRoute: typeof OnboardingLanguageRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/talk': {
      id: '/onboarding/talk'
      path: '/talk'
      fullPath: '/onboarding/talk'
      preLoaderRoute: typeof OnboardingTalkRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/appearance': {
      id: '/_app/account/appearance'
      path: '/appearance'
      fullPath: '/account/appearance'
      preLoaderRoute: typeof AppAccountAppearanceRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/delete': {
      id: '/_app/account/delete'
      path: '/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AppAccountDeleteRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/language': {
      id: '/_app/account/language'
      path: '/language'
      fullPath: '/account/language'
      preLoaderRoute: typeof AppAccountLanguageRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/voice': {
      id: '/_app/account/voice'
      path: '/voice'
      fullPath: '/account/voice'
      preLoaderRoute: typeof AppAccountVoiceRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/workspaces': {
      id: '/_app/account/workspaces'
      path: '/workspaces'
      fullPath: '/account/workspaces'
      preLoaderRoute: typeof AppAccountWorkspacesRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/business/': {
      id: '/_app/business/'
      path: '/'
      fullPath: '/business/'
      preLoaderRoute: typeof AppBusinessIndexRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/_team': {
      id: '/_app/business/_team'
      path: ''
      fullPath: '/business'
      preLoaderRoute: typeof AppBusinessTeamRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/knows': {
      id: '/_app/business/knows'
      path: '/knows'
      fullPath: '/business/knows'
      preLoaderRoute: typeof AppBusinessKnowsRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/map': {
      id: '/_app/business/map'
      path: '/map'
      fullPath: '/business/map'
      preLoaderRoute: typeof AppBusinessMapRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/coach/': {
      id: '/_app/coach/'
      path: '/'
      fullPath: '/coach/'
      preLoaderRoute: typeof AppCoachIndexRouteImport
      parentRoute: typeof AppCoachRouteRoute
    }
    '/_app/coach/$threadId': {
      id: '/_app/coach/$threadId'
      path: '/$threadId'
      fullPath: '/coach/$threadId'
      preLoaderRoute: typeof AppCoachThreadIdRouteImport
      parentRoute: typeof AppCoachRouteRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/arrange': {
      id: '/_app/dashboard/arrange'
      path: '/dashboard/arrange'
      fullPath: '/dashboard/arrange'
      preLoaderRoute: typeof AppDashboardArrangeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/new': {
      id: '/_app/dashboard/new'
      path: '/dashboard/new'
      fullPath: '/dashboard/new'
      preLoaderRoute: typeof AppDashboardNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/ai-first': {
      id: '/_app/dev/ai-first'
      path: '/dev/ai-first'
      fullPath: '/dev/ai-first'
      preLoaderRoute: typeof AppDevAiFirstRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/': {
      id: '/_app/lists/'
      path: '/lists'
      fullPath: '/lists/'
      preLoaderRoute: typeof AppListsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/$listId': {
      id: '/_app/lists/$listId'
      path: '/lists/$listId'
      fullPath: '/lists/$listId'
      preLoaderRoute: typeof AppListsListIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/new-record/': {
      id: '/_app/new-record/'
      path: '/new-record'
      fullPath: '/new-record/'
      preLoaderRoute: typeof AppNewRecordIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/records/': {
      id: '/_app/records/'
      path: '/records'
      fullPath: '/records/'
      preLoaderRoute: typeof AppRecordsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/records/$recordId': {
      id: '/_app/records/$recordId'
      path: '/records/$recordId'
      fullPath: '/records/$recordId'
      preLoaderRoute: typeof AppRecordsRecordIdRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/edit/': {
      id: '/onboarding/edit/'
      path: '/edit'
      fullPath: '/onboarding/edit/'
      preLoaderRoute: typeof OnboardingEditIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/_app/account/about/': {
      id: '/_app/account/about/'
      path: '/about'
      fullPath: '/account/about/'
      preLoaderRoute: typeof AppAccountAboutIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/about/terms': {
      id: '/_app/account/about/terms'
      path: '/about/terms'
      fullPath: '/account/about/terms'
      preLoaderRoute: typeof AppAccountAboutTermsRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/business/_team/invite': {
      id: '/_app/business/_team/invite'
      path: '/invite'
      fullPath: '/business/invite'
      preLoaderRoute: typeof AppBusinessTeamInviteRouteImport
      parentRoute: typeof AppBusinessTeamRoute
    }
    '/_app/business/_team/team': {
      id: '/_app/business/_team/team'
      path: '/team'
      fullPath: '/business/team'
      preLoaderRoute: typeof AppBusinessTeamTeamRouteImport
      parentRoute: typeof AppBusinessTeamRoute
    }
    '/_app/business/connectors/': {
      id: '/_app/business/connectors/'
      path: '/connectors'
      fullPath: '/business/connectors/'
      preLoaderRoute: typeof AppBusinessConnectorsIndexRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/jobs/': {
      id: '/_app/business/jobs/'
      path: '/jobs'
      fullPath: '/business/jobs/'
      preLoaderRoute: typeof AppBusinessJobsIndexRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/jobs/$': {
      id: '/_app/business/jobs/$'
      path: '/jobs/$'
      fullPath: '/business/jobs/$'
      preLoaderRoute: typeof AppBusinessJobsSplatRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/people/$userId': {
      id: '/_app/business/people/$userId'
      path: '/people/$userId'
      fullPath: '/business/people/$userId'
      preLoaderRoute: typeof AppBusinessPeopleUserIdRouteRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/roles/': {
      id: '/_app/business/roles/'
      path: '/roles'
      fullPath: '/business/roles/'
      preLoaderRoute: typeof AppBusinessRolesIndexRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/roles/$roleId': {
      id: '/_app/business/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/business/roles/$roleId'
      preLoaderRoute: typeof AppBusinessRolesRoleIdRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/roles/new': {
      id: '/_app/business/roles/new'
      path: '/roles/new'
      fullPath: '/business/roles/new'
      preLoaderRoute: typeof AppBusinessRolesNewRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/coach/imports/setup': {
      id: '/_app/coach/imports/setup'
      path: '/imports/setup'
      fullPath: '/coach/imports/setup'
      preLoaderRoute: typeof AppCoachImportsSetupRouteImport
      parentRoute: typeof AppCoachRouteRoute
    }
    '/_app/dashboard/$cardId/': {
      id: '/_app/dashboard/$cardId/'
      path: '/dashboard/$cardId'
      fullPath: '/dashboard/$cardId/'
      preLoaderRoute: typeof AppDashboardCardIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/$cardId/edit': {
      id: '/_app/dashboard/$cardId/edit'
      path: '/dashboard/$cardId/edit'
      fullPath: '/dashboard/$cardId/edit'
      preLoaderRoute: typeof AppDashboardCardIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/records/$recordId/': {
      id: '/_app/records/$recordId/'
      path: '/'
      fullPath: '/records/$recordId/'
      preLoaderRoute: typeof AppRecordsRecordIdIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/access': {
      id: '/_app/records/$recordId/access'
      path: '/access'
      fullPath: '/records/$recordId/access'
      preLoaderRoute: typeof AppRecordsRecordIdAccessRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/customize': {
      id: '/_app/records/$recordId/customize'
      path: '/customize'
      fullPath: '/records/$recordId/customize'
      preLoaderRoute: typeof AppRecordsRecordIdCustomizeRouteRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/new-entry': {
      id: '/_app/records/$recordId/new-entry'
      path: '/new-entry'
      fullPath: '/records/$recordId/new-entry'
      preLoaderRoute: typeof AppRecordsRecordIdNewEntryRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/sheet': {
      id: '/_app/records/$recordId/sheet'
      path: '/sheet'
      fullPath: '/records/$recordId/sheet'
      preLoaderRoute: typeof AppRecordsRecordIdSheetRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/business/connectors/gmail/': {
      id: '/_app/business/connectors/gmail/'
      path: '/connectors/gmail'
      fullPath: '/business/connectors/gmail/'
      preLoaderRoute: typeof AppBusinessConnectorsGmailIndexRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/business/people/$userId/': {
      id: '/_app/business/people/$userId/'
      path: '/'
      fullPath: '/business/people/$userId/'
      preLoaderRoute: typeof AppBusinessPeopleUserIdIndexRouteImport
      parentRoute: typeof AppBusinessPeopleUserIdRouteRoute
    }
    '/_app/business/people/$userId/access': {
      id: '/_app/business/people/$userId/access'
      path: '/access'
      fullPath: '/business/people/$userId/access'
      preLoaderRoute: typeof AppBusinessPeopleUserIdAccessRouteImport
      parentRoute: typeof AppBusinessPeopleUserIdRouteRoute
    }
    '/_app/business/people/$userId/activity': {
      id: '/_app/business/people/$userId/activity'
      path: '/activity'
      fullPath: '/business/people/$userId/activity'
      preLoaderRoute: typeof AppBusinessPeopleUserIdActivityRouteImport
      parentRoute: typeof AppBusinessPeopleUserIdRouteRoute
    }
    '/_app/business/people/$userId/information': {
      id: '/_app/business/people/$userId/information'
      path: '/information'
      fullPath: '/business/people/$userId/information'
      preLoaderRoute: typeof AppBusinessPeopleUserIdInformationRouteImport
      parentRoute: typeof AppBusinessPeopleUserIdRouteRoute
    }
    '/_app/business/people/$userId/team': {
      id: '/_app/business/people/$userId/team'
      path: '/team'
      fullPath: '/business/people/$userId/team'
      preLoaderRoute: typeof AppBusinessPeopleUserIdTeamRouteImport
      parentRoute: typeof AppBusinessPeopleUserIdRouteRoute
    }
    '/_app/coach/imports/$importId/': {
      id: '/_app/coach/imports/$importId/'
      path: '/imports/$importId'
      fullPath: '/coach/imports/$importId/'
      preLoaderRoute: typeof AppCoachImportsImportIdIndexRouteImport
      parentRoute: typeof AppCoachRouteRoute
    }
    '/_app/coach/imports/$importId/aside': {
      id: '/_app/coach/imports/$importId/aside'
      path: '/imports/$importId/aside'
      fullPath: '/coach/imports/$importId/aside'
      preLoaderRoute: typeof AppCoachImportsImportIdAsideRouteImport
      parentRoute: typeof AppCoachRouteRoute
    }
    '/_app/records/$recordId/customize/': {
      id: '/_app/records/$recordId/customize/'
      path: '/'
      fullPath: '/records/$recordId/customize/'
      preLoaderRoute: typeof AppRecordsRecordIdCustomizeIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdCustomizeRouteRoute
    }
    '/_app/records/$recordId/customize/formula': {
      id: '/_app/records/$recordId/customize/formula'
      path: '/formula'
      fullPath: '/records/$recordId/customize/formula'
      preLoaderRoute: typeof AppRecordsRecordIdCustomizeFormulaRouteImport
      parentRoute: typeof AppRecordsRecordIdCustomizeRouteRoute
    }
    '/_app/records/$recordId/insights/': {
      id: '/_app/records/$recordId/insights/'
      path: '/insights'
      fullPath: '/records/$recordId/insights/'
      preLoaderRoute: typeof AppRecordsRecordIdInsightsIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/insights/arrange': {
      id: '/_app/records/$recordId/insights/arrange'
      path: '/insights/arrange'
      fullPath: '/records/$recordId/insights/arrange'
      preLoaderRoute: typeof AppRecordsRecordIdInsightsArrangeRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/insights/new': {
      id: '/_app/records/$recordId/insights/new'
      path: '/insights/new'
      fullPath: '/records/$recordId/insights/new'
      preLoaderRoute: typeof AppRecordsRecordIdInsightsNewRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/links/': {
      id: '/_app/records/$recordId/links/'
      path: '/links'
      fullPath: '/records/$recordId/links/'
      preLoaderRoute: typeof AppRecordsRecordIdLinksIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/links/$linkId': {
      id: '/_app/records/$recordId/links/$linkId'
      path: '/links/$linkId'
      fullPath: '/records/$recordId/links/$linkId'
      preLoaderRoute: typeof AppRecordsRecordIdLinksLinkIdRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/links/new': {
      id: '/_app/records/$recordId/links/new'
      path: '/links/new'
      fullPath: '/records/$recordId/links/new'
      preLoaderRoute: typeof AppRecordsRecordIdLinksNewRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/report-templates/': {
      id: '/_app/records/$recordId/report-templates/'
      path: '/report-templates'
      fullPath: '/records/$recordId/report-templates/'
      preLoaderRoute: typeof AppRecordsRecordIdReportTemplatesIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/report-templates/new': {
      id: '/_app/records/$recordId/report-templates/new'
      path: '/report-templates/new'
      fullPath: '/records/$recordId/report-templates/new'
      preLoaderRoute: typeof AppRecordsRecordIdReportTemplatesNewRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/business/connectors/gmail/rules/new': {
      id: '/_app/business/connectors/gmail/rules/new'
      path: '/connectors/gmail/rules/new'
      fullPath: '/business/connectors/gmail/rules/new'
      preLoaderRoute: typeof AppBusinessConnectorsGmailRulesNewRouteImport
      parentRoute: typeof AppBusinessRouteRoute
    }
    '/_app/records/$recordId/entries/$entryId/': {
      id: '/_app/records/$recordId/entries/$entryId/'
      path: '/entries/$entryId'
      fullPath: '/records/$recordId/entries/$entryId/'
      preLoaderRoute: typeof AppRecordsRecordIdEntriesEntryIdIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/entries/$entryId/edit': {
      id: '/_app/records/$recordId/entries/$entryId/edit'
      path: '/entries/$entryId/edit'
      fullPath: '/records/$recordId/entries/$entryId/edit'
      preLoaderRoute: typeof AppRecordsRecordIdEntriesEntryIdEditRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/entries/$entryId/full': {
      id: '/_app/records/$recordId/entries/$entryId/full'
      path: '/entries/$entryId/full'
      fullPath: '/records/$recordId/entries/$entryId/full'
      preLoaderRoute: typeof AppRecordsRecordIdEntriesEntryIdFullRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/insights/$cardId/': {
      id: '/_app/records/$recordId/insights/$cardId/'
      path: '/insights/$cardId'
      fullPath: '/records/$recordId/insights/$cardId/'
      preLoaderRoute: typeof AppRecordsRecordIdInsightsCardIdIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/insights/$cardId/edit': {
      id: '/_app/records/$recordId/insights/$cardId/edit'
      path: '/insights/$cardId/edit'
      fullPath: '/records/$recordId/insights/$cardId/edit'
      preLoaderRoute: typeof AppRecordsRecordIdInsightsCardIdEditRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/report-templates/$templateId/': {
      id: '/_app/records/$recordId/report-templates/$templateId/'
      path: '/report-templates/$templateId'
      fullPath: '/records/$recordId/report-templates/$templateId/'
      preLoaderRoute: typeof AppRecordsRecordIdReportTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
    '/_app/records/$recordId/report-templates/$templateId/edit': {
      id: '/_app/records/$recordId/report-templates/$templateId/edit'
      path: '/report-templates/$templateId/edit'
      fullPath: '/records/$recordId/report-templates/$templateId/edit'
      preLoaderRoute: typeof AppRecordsRecordIdReportTemplatesTemplateIdEditRouteImport
      parentRoute: typeof AppRecordsRecordIdRouteRoute
    }
  }
}

interface OnboardingRouteRouteChildren {
  OnboardingLanguageRoute: typeof OnboardingLanguageRoute
  OnboardingTalkRoute: typeof OnboardingTalkRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  OnboardingEditIndexRoute: typeof OnboardingEditIndexRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingLanguageRoute: OnboardingLanguageRoute,
  OnboardingTalkRoute: OnboardingTalkRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  OnboardingEditIndexRoute: OnboardingEditIndexRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface AppAccountRouteRouteChildren {
  AppAccountAppearanceRoute: typeof AppAccountAppearanceRoute
  AppAccountDeleteRoute: typeof AppAccountDeleteRoute
  AppAccountLanguageRoute: typeof AppAccountLanguageRoute
  AppAccountVoiceRoute: typeof AppAccountVoiceRoute
  AppAccountWorkspacesRoute: typeof AppAccountWorkspacesRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppAccountAboutTermsRoute: typeof AppAccountAboutTermsRoute
  AppAccountAboutIndexRoute: typeof AppAccountAboutIndexRoute
}

const AppAccountRouteRouteChildren: AppAccountRouteRouteChildren = {
  AppAccountAppearanceRoute: AppAccountAppearanceRoute,
  AppAccountDeleteRoute: AppAccountDeleteRoute,
  AppAccountLanguageRoute: AppAccountLanguageRoute,
  AppAccountVoiceRoute: AppAccountVoiceRoute,
  AppAccountWorkspacesRoute: AppAccountWorkspacesRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppAccountAboutTermsRoute: AppAccountAboutTermsRoute,
  AppAccountAboutIndexRoute: AppAccountAboutIndexRoute,
}

const AppAccountRouteRouteWithChildren = AppAccountRouteRoute._addFileChildren(
  AppAccountRouteRouteChildren,
)

interface AppBusinessTeamRouteChildren {
  AppBusinessTeamInviteRoute: typeof AppBusinessTeamInviteRoute
  AppBusinessTeamTeamRoute: typeof AppBusinessTeamTeamRoute
}

const AppBusinessTeamRouteChildren: AppBusinessTeamRouteChildren = {
  AppBusinessTeamInviteRoute: AppBusinessTeamInviteRoute,
  AppBusinessTeamTeamRoute: AppBusinessTeamTeamRoute,
}

const AppBusinessTeamRouteWithChildren = AppBusinessTeamRoute._addFileChildren(
  AppBusinessTeamRouteChildren,
)

interface AppBusinessPeopleUserIdRouteRouteChildren {
  AppBusinessPeopleUserIdAccessRoute: typeof AppBusinessPeopleUserIdAccessRoute
  AppBusinessPeopleUserIdActivityRoute: typeof AppBusinessPeopleUserIdActivityRoute
  AppBusinessPeopleUserIdInformationRoute: typeof AppBusinessPeopleUserIdInformationRoute
  AppBusinessPeopleUserIdTeamRoute: typeof AppBusinessPeopleUserIdTeamRoute
  AppBusinessPeopleUserIdIndexRoute: typeof AppBusinessPeopleUserIdIndexRoute
}

const AppBusinessPeopleUserIdRouteRouteChildren: AppBusinessPeopleUserIdRouteRouteChildren =
  {
    AppBusinessPeopleUserIdAccessRoute: AppBusinessPeopleUserIdAccessRoute,
    AppBusinessPeopleUserIdActivityRoute: AppBusinessPeopleUserIdActivityRoute,
    AppBusinessPeopleUserIdInformationRoute:
      AppBusinessPeopleUserIdInformationRoute,
    AppBusinessPeopleUserIdTeamRoute: AppBusinessPeopleUserIdTeamRoute,
    AppBusinessPeopleUserIdIndexRoute: AppBusinessPeopleUserIdIndexRoute,
  }

const AppBusinessPeopleUserIdRouteRouteWithChildren =
  AppBusinessPeopleUserIdRouteRoute._addFileChildren(
    AppBusinessPeopleUserIdRouteRouteChildren,
  )

interface AppBusinessRouteRouteChildren {
  AppBusinessTeamRoute: typeof AppBusinessTeamRouteWithChildren
  AppBusinessKnowsRoute: typeof AppBusinessKnowsRoute
  AppBusinessMapRoute: typeof AppBusinessMapRoute
  AppBusinessIndexRoute: typeof AppBusinessIndexRoute
  AppBusinessPeopleUserIdRouteRoute: typeof AppBusinessPeopleUserIdRouteRouteWithChildren
  AppBusinessJobsSplatRoute: typeof AppBusinessJobsSplatRoute
  AppBusinessRolesRoleIdRoute: typeof AppBusinessRolesRoleIdRoute
  AppBusinessRolesNewRoute: typeof AppBusinessRolesNewRoute
  AppBusinessConnectorsIndexRoute: typeof AppBusinessConnectorsIndexRoute
  AppBusinessJobsIndexRoute: typeof AppBusinessJobsIndexRoute
  AppBusinessRolesIndexRoute: typeof AppBusinessRolesIndexRoute
  AppBusinessConnectorsGmailIndexRoute: typeof AppBusinessConnectorsGmailIndexRoute
  AppBusinessConnectorsGmailRulesNewRoute: typeof AppBusinessConnectorsGmailRulesNewRoute
}

const AppBusinessRouteRouteChildren: AppBusinessRouteRouteChildren = {
  AppBusinessTeamRoute: AppBusinessTeamRouteWithChildren,
  AppBusinessKnowsRoute: AppBusinessKnowsRoute,
  AppBusinessMapRoute: AppBusinessMapRoute,
  AppBusinessIndexRoute: AppBusinessIndexRoute,
  AppBusinessPeopleUserIdRouteRoute:
    AppBusinessPeopleUserIdRouteRouteWithChildren,
  AppBusinessJobsSplatRoute: AppBusinessJobsSplatRoute,
  AppBusinessRolesRoleIdRoute: AppBusinessRolesRoleIdRoute,
  AppBusinessRolesNewRoute: AppBusinessRolesNewRoute,
  AppBusinessConnectorsIndexRoute: AppBusinessConnectorsIndexRoute,
  AppBusinessJobsIndexRoute: AppBusinessJobsIndexRoute,
  AppBusinessRolesIndexRoute: AppBusinessRolesIndexRoute,
  AppBusinessConnectorsGmailIndexRoute: AppBusinessConnectorsGmailIndexRoute,
  AppBusinessConnectorsGmailRulesNewRoute:
    AppBusinessConnectorsGmailRulesNewRoute,
}

const AppBusinessRouteRouteWithChildren =
  AppBusinessRouteRoute._addFileChildren(AppBusinessRouteRouteChildren)

interface AppCoachRouteRouteChildren {
  AppCoachThreadIdRoute: typeof AppCoachThreadIdRoute
  AppCoachIndexRoute: typeof AppCoachIndexRoute
  AppCoachImportsSetupRoute: typeof AppCoachImportsSetupRoute
  AppCoachImportsImportIdAsideRoute: typeof AppCoachImportsImportIdAsideRoute
  AppCoachImportsImportIdIndexRoute: typeof AppCoachImportsImportIdIndexRoute
}

const AppCoachRouteRouteChildren: AppCoachRouteRouteChildren = {
  AppCoachThreadIdRoute: AppCoachThreadIdRoute,
  AppCoachIndexRoute: AppCoachIndexRoute,
  AppCoachImportsSetupRoute: AppCoachImportsSetupRoute,
  AppCoachImportsImportIdAsideRoute: AppCoachImportsImportIdAsideRoute,
  AppCoachImportsImportIdIndexRoute: AppCoachImportsImportIdIndexRoute,
}

const AppCoachRouteRouteWithChildren = AppCoachRouteRoute._addFileChildren(
  AppCoachRouteRouteChildren,
)

interface AppRecordsRecordIdCustomizeRouteRouteChildren {
  AppRecordsRecordIdCustomizeFormulaRoute: typeof AppRecordsRecordIdCustomizeFormulaRoute
  AppRecordsRecordIdCustomizeIndexRoute: typeof AppRecordsRecordIdCustomizeIndexRoute
}

const AppRecordsRecordIdCustomizeRouteRouteChildren: AppRecordsRecordIdCustomizeRouteRouteChildren =
  {
    AppRecordsRecordIdCustomizeFormulaRoute:
      AppRecordsRecordIdCustomizeFormulaRoute,
    AppRecordsRecordIdCustomizeIndexRoute:
      AppRecordsRecordIdCustomizeIndexRoute,
  }

const AppRecordsRecordIdCustomizeRouteRouteWithChildren =
  AppRecordsRecordIdCustomizeRouteRoute._addFileChildren(
    AppRecordsRecordIdCustomizeRouteRouteChildren,
  )

interface AppRecordsRecordIdRouteRouteChildren {
  AppRecordsRecordIdCustomizeRouteRoute: typeof AppRecordsRecordIdCustomizeRouteRouteWithChildren
  AppRecordsRecordIdAccessRoute: typeof AppRecordsRecordIdAccessRoute
  AppRecordsRecordIdNewEntryRoute: typeof AppRecordsRecordIdNewEntryRoute
  AppRecordsRecordIdSheetRoute: typeof AppRecordsRecordIdSheetRoute
  AppRecordsRecordIdIndexRoute: typeof AppRecordsRecordIdIndexRoute
  AppRecordsRecordIdInsightsArrangeRoute: typeof AppRecordsRecordIdInsightsArrangeRoute
  AppRecordsRecordIdInsightsNewRoute: typeof AppRecordsRecordIdInsightsNewRoute
  AppRecordsRecordIdLinksLinkIdRoute: typeof AppRecordsRecordIdLinksLinkIdRoute
  AppRecordsRecordIdLinksNewRoute: typeof AppRecordsRecordIdLinksNewRoute
  AppRecordsRecordIdReportTemplatesNewRoute: typeof AppRecordsRecordIdReportTemplatesNewRoute
  AppRecordsRecordIdInsightsIndexRoute: typeof AppRecordsRecordIdInsightsIndexRoute
  AppRecordsRecordIdLinksIndexRoute: typeof AppRecordsRecordIdLinksIndexRoute
  AppRecordsRecordIdReportTemplatesIndexRoute: typeof AppRecordsRecordIdReportTemplatesIndexRoute
  AppRecordsRecordIdEntriesEntryIdEditRoute: typeof AppRecordsRecordIdEntriesEntryIdEditRoute
  AppRecordsRecordIdEntriesEntryIdFullRoute: typeof AppRecordsRecordIdEntriesEntryIdFullRoute
  AppRecordsRecordIdInsightsCardIdEditRoute: typeof AppRecordsRecordIdInsightsCardIdEditRoute
  AppRecordsRecordIdReportTemplatesTemplateIdEditRoute: typeof AppRecordsRecordIdReportTemplatesTemplateIdEditRoute
  AppRecordsRecordIdEntriesEntryIdIndexRoute: typeof AppRecordsRecordIdEntriesEntryIdIndexRoute
  AppRecordsRecordIdInsightsCardIdIndexRoute: typeof AppRecordsRecordIdInsightsCardIdIndexRoute
  AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute: typeof AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute
}

const AppRecordsRecordIdRouteRouteChildren: AppRecordsRecordIdRouteRouteChildren =
  {
    AppRecordsRecordIdCustomizeRouteRoute:
      AppRecordsRecordIdCustomizeRouteRouteWithChildren,
    AppRecordsRecordIdAccessRoute: AppRecordsRecordIdAccessRoute,
    AppRecordsRecordIdNewEntryRoute: AppRecordsRecordIdNewEntryRoute,
    AppRecordsRecordIdSheetRoute: AppRecordsRecordIdSheetRoute,
    AppRecordsRecordIdIndexRoute: AppRecordsRecordIdIndexRoute,
    AppRecordsRecordIdInsightsArrangeRoute:
      AppRecordsRecordIdInsightsArrangeRoute,
    AppRecordsRecordIdInsightsNewRoute: AppRecordsRecordIdInsightsNewRoute,
    AppRecordsRecordIdLinksLinkIdRoute: AppRecordsRecordIdLinksLinkIdRoute,
    AppRecordsRecordIdLinksNewRoute: AppRecordsRecordIdLinksNewRoute,
    AppRecordsRecordIdReportTemplatesNewRoute:
      AppRecordsRecordIdReportTemplatesNewRoute,
    AppRecordsRecordIdInsightsIndexRoute: AppRecordsRecordIdInsightsIndexRoute,
    AppRecordsRecordIdLinksIndexRoute: AppRecordsRecordIdLinksIndexRoute,
    AppRecordsRecordIdReportTemplatesIndexRoute:
      AppRecordsRecordIdReportTemplatesIndexRoute,
    AppRecordsRecordIdEntriesEntryIdEditRoute:
      AppRecordsRecordIdEntriesEntryIdEditRoute,
    AppRecordsRecordIdEntriesEntryIdFullRoute:
      AppRecordsRecordIdEntriesEntryIdFullRoute,
    AppRecordsRecordIdInsightsCardIdEditRoute:
      AppRecordsRecordIdInsightsCardIdEditRoute,
    AppRecordsRecordIdReportTemplatesTemplateIdEditRoute:
      AppRecordsRecordIdReportTemplatesTemplateIdEditRoute,
    AppRecordsRecordIdEntriesEntryIdIndexRoute:
      AppRecordsRecordIdEntriesEntryIdIndexRoute,
    AppRecordsRecordIdInsightsCardIdIndexRoute:
      AppRecordsRecordIdInsightsCardIdIndexRoute,
    AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute:
      AppRecordsRecordIdReportTemplatesTemplateIdIndexRoute,
  }

const AppRecordsRecordIdRouteRouteWithChildren =
  AppRecordsRecordIdRouteRoute._addFileChildren(
    AppRecordsRecordIdRouteRouteChildren,
  )

interface AppRouteChildren {
  AppAccountRouteRoute: typeof AppAccountRouteRouteWithChildren
  AppBusinessRouteRoute: typeof AppBusinessRouteRouteWithChildren
  AppCoachRouteRoute: typeof AppCoachRouteRouteWithChildren
  AppSearchRoute: typeof AppSearchRoute
  AppIndexRoute: typeof AppIndexRoute
  AppRecordsRecordIdRouteRoute: typeof AppRecordsRecordIdRouteRouteWithChildren
  AppDashboardArrangeRoute: typeof AppDashboardArrangeRoute
  AppDashboardNewRoute: typeof AppDashboardNewRoute
  AppDevAiFirstRoute: typeof AppDevAiFirstRoute
  AppListsListIdRoute: typeof AppListsListIdRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppListsIndexRoute: typeof AppListsIndexRoute
  AppNewRecordIndexRoute: typeof AppNewRecordIndexRoute
  AppRecordsIndexRoute: typeof AppRecordsIndexRoute
  AppDashboardCardIdEditRoute: typeof AppDashboardCardIdEditRoute
  AppDashboardCardIdIndexRoute: typeof AppDashboardCardIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRouteRoute: AppAccountRouteRouteWithChildren,
  AppBusinessRouteRoute: AppBusinessRouteRouteWithChildren,
  AppCoachRouteRoute: AppCoachRouteRouteWithChildren,
  AppSearchRoute: AppSearchRoute,
  AppIndexRoute: AppIndexRoute,
  AppRecordsRecordIdRouteRoute: AppRecordsRecordIdRouteRouteWithChildren,
  AppDashboardArrangeRoute: AppDashboardArrangeRoute,
  AppDashboardNewRoute: AppDashboardNewRoute,
  AppDevAiFirstRoute: AppDevAiFirstRoute,
  AppListsListIdRoute: AppListsListIdRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppListsIndexRoute: AppListsIndexRoute,
  AppNewRecordIndexRoute: AppNewRecordIndexRoute,
  AppRecordsIndexRoute: AppRecordsIndexRoute,
  AppDashboardCardIdEditRoute: AppDashboardCardIdEditRoute,
  AppDashboardCardIdIndexRoute: AppDashboardCardIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicPrivacyRoute: typeof PublicPrivacyRoute
  PublicTermsRoute: typeof PublicTermsRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicPrivacyRoute: PublicPrivacyRoute,
  PublicTermsRoute: PublicTermsRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  CreateAccountRoute: CreateAccountRoute,
  GetStartedRoute: GetStartedRoute,
  JoinRoute: JoinRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  DevBootRoute: DevBootRoute,
  DevCanvasRoute: DevCanvasRoute,
  DevGraphicsRoute: DevGraphicsRoute,
  DevKitRoute: DevKitRoute,
  DevStudioRoute: DevStudioRoute,
  DevVoiceRoute: DevVoiceRoute,
  PTokenRoute: PTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
